<template>
<!--携宠查询页面-->
  <div style="margin: 20px">

    <el-form :inline="true" :model="form" class="demo-form-inline">
      <el-form-item label="手机号">
        <el-input v-model="form.phone" placeholder="请输入手机号"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">查询</el-button>
      </el-form-item>
    </el-form>
    <el-descriptions class="margin-top"  :column="1" border>
      <el-descriptions-item label="手机号">{{pets.phone}}</el-descriptions-item>
      <el-descriptions-item label="购票姓名">{{pets.username}}</el-descriptions-item>
      <el-descriptions-item label="宠物品类/名称">{{pets.petCategory}}</el-descriptions-item>
      <el-descriptions-item label="审核结果">{{pets.auditResult}}</el-descriptions-item>
    </el-descriptions>
  </div>

</template>

<script>
  import Layout from '../../components/common/Layout.vue'
  import AboutFour from "../../components/elements/about/AboutFour.vue";
  import carousel from "../../components/elements/carousel/carousel.vue";
  import SlideVerify from "../../components/elements/about/SlideVerify.vue";
  import { Api } from '@/utils/api';
  export default {
    name: 'ticketing',
    components: { Layout,AboutFour,carousel,SlideVerify},
    data() {
      return {
        input:'',
        form:{},
        pets: {},
      }
    },

    methods:{
      init(){

      },

      onSubmit() {
        Api.petFriendly(this.form).then(res => {

         this.pets = res?res:{};
        });
      }
    }
  }
</script>
<style>
.mask {
  position: fixed;
  left: 0%;
  top: 0%;
  width: 100%;
  height: 100%;
  z-index: 100;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.5);
}
.mask .slideContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
  width: 380px;
  height: 250px;
  background-color: rgb(255, 255, 255);
}
  .el-input--medium .el-input__inner {
    height: 50px;
    line-height: 50px;
    border-radius: 2px;
    width: 100%;
  }
  .el-input--medium {
    font-size: 14px;
    width: 100%;
  }
  .el-select {
    display: inline-block;
    position: relative;
    width: 100%;
  }
  p{
      padding: 0px;
      margin: 0px;
      text-align: left;
  }
</style>
